import { Routes } from '@angular/router';
import { knightmedsInstanceGuard } from '../guards/knightmeds-instance.guard';
import { ReleasePagesComponent } from './release-pages.component';
import { PatientsPageComponent } from './pages/patients-page/patients-page.component';
import { MedicationsPageComponent } from './pages/medications-page/medications-page.component';
import { ReleasePageComponent } from './pages/release-page/release-page.component';
import {
  PATH_RELEASE_PAGES,
  PATH_PATIENTS,
  PATH_MEDICATIONS,
  PATH_PATIENT_ID,
  PATH_RELEASE,
  PATH_PROVIDER_ORDER_ID,
} from 'src/app/global';

export const releasePagesRoutes: Routes = [
  {
    path: PATH_RELEASE_PAGES,
    component: ReleasePagesComponent,
    canActivate: [knightmedsInstanceGuard],
    children: [
      { path: '', redirectTo: PATH_PATIENTS, pathMatch: 'full' },
      {
        path: PATH_PATIENTS,
        component: PatientsPageComponent,
      },
      {
        path: `${PATH_MEDICATIONS}/:${PATH_PATIENT_ID}`,
        component: MedicationsPageComponent,
      },
      {
        path: `${PATH_RELEASE}/:${PATH_PATIENT_ID}/:${PATH_PROVIDER_ORDER_ID}`,
        component: ReleasePageComponent,
      },
    ],
  },
];
